enum PaymentTransactionStatus {
  ACTV = 'ACTV',
  PRSY = 'PRSY',
  NEXT = 'NEXT',
  ACCP = 'ACCP',
  ACSC = 'ACSC',
  ACSP = 'ACSP',
  ACTC = 'ACTC',
  ACWC = 'ACWC',
  ACWP = 'ACWP',
  CANC = 'CANC',
  NAUT = 'NAUT',
  PDNG = 'PDNG',
  RCVD = 'RCVD',
  RJCT = 'RJCT',
}

export default PaymentTransactionStatus;
